/* global ga */
import React from 'react';
import PropTypes from 'prop-types';

import { getLoginImagePath } from '../utils/getExternalImagePath';

import FooterSimplifiedBlockList from './components/FooterSimplifiedBlockList';
import FooterSimplifiedLink from './components/FooterSimplifiedLink';
import FooterSimplifiedStoreIcon from './components/FooterSimplifiedStoreIcon';

const track = ({ eventCategory, eventAction, eventLabel }) => {
  if (typeof ga === 'function') {
    ga('send', {
      hitType: 'event',
      eventCategory,
      eventAction,
      eventLabel
    });
  }
};

const AppFooter = ({ android, ios }) => (
  <>
    <FooterSimplifiedBlockList isInline>
      <FooterSimplifiedLink href={ios.link} onClick={() => track(ios)}>
        <FooterSimplifiedStoreIcon
          src={getLoginImagePath('app-store.png')}
          alt="App Store"
        />
      </FooterSimplifiedLink>
      <FooterSimplifiedLink href={android.link} onClick={() => track(android)}>
        <FooterSimplifiedStoreIcon
          src={getLoginImagePath('google-play.png')}
          alt="Google Play Store"
        />
      </FooterSimplifiedLink>
    </FooterSimplifiedBlockList>
  </>
);

AppFooter.propTypes = {
  android: PropTypes.shape({
    link: PropTypes.string,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    eventLabel: PropTypes.string
  }),
  ios: PropTypes.shape({
    link: PropTypes.string,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    eventLabel: PropTypes.string
  })
};

AppFooter.defaultProps = {
  android: {
    link: 'https://spotahome.app.link/footer-icon-android',
    eventCategory: 'app-promotion',
    eventAction: 'footer-icon-android',
    eventLabel: 'open'
  },
  ios: {
    link: 'https://spotahome.app.link/footer-icon-ios',
    eventCategory: 'app-promotion',
    eventAction: 'footer-icon-ios',
    eventLabel: 'open'
  }
};

export default AppFooter;
